import ConsolaAudio from './consola-audio';
export default ConsolaAudio;